module.exports = __webpack_public_path__ + "static/img/refresh.fbf1aaa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/refresh.png
// module id = Ac4m
// module chunks = 1